import axios from "axios";
import { baseUrl } from "../utils/constants";

// Get Sole-Trader Chart Data //
export const soleTraderChartDataApi = async (userToken) => {
  return new Promise(async (resolve, reject) => {
    const url = `${baseUrl}/contractor/get-sole-trader-stats`;

    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      
      const data = response.data.data;
      
      const status = [];
      const count = [];
      data.forEach((element) => {
        status.push(element.status);
        count.push(element.count);
      });
      let total = 0;

      for (let i = 0; i < count.length; i++) {
        total += count[i];
      }
      resolve({ status: status, count: count, total: total });
    } catch (error) {
      console.log("api error::", error);
      reject(error);
    }
  });
};

// get-contractor-stats //
export const getContractorStatsApi = async (userToken) => {
  return new Promise(async (resolve, reject) => {
    const url = `${baseUrl}/contractor/get-contractor-stats`;
    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      resolve(response.data);
    } catch (error) {
      console.log("get-contractor-stats::", error);
      reject(error);
    }
  });
};
